import React from "react";
import SummariesHeader from "./SummariesHeader";
import SummariesItems from "./SummariesItems";
import { Grid } from "../../containers/grid/Grid";
import { TexTranslateDefault } from "../../../translations/FlattenMessages";
import { useIntl } from "react-intl";
import { ProgressBarValue } from "../../elements/progressBarValue/ProgressBarValue";



export default function SummariesBody({ data, dictionary }) {
  const intl = useIntl();
  const processResumeType = (dataSummary) => {
    const resultData = dataSummary ? JSON.parse(JSON.stringify(dataSummary)) : {};
    if (resultData.header?.module) {
      switch (resultData.header.module) {
        
        case "concentrationOpportunities":
          if (resultData.header.showTitle === true) {
            
            resultData.header.icon = "bi bi-reception-3";
            resultData.header.title = "Concentration Opportunities";
          }
          if(resultData.dataTable && resultData.dataTable.length > 0){
            resultData.dataTable.forEach(obj=>{
              if(obj.nombreProveedor === "others" && obj.total){
                obj.nombreProveedor = `${TexTranslateDefault(intl, "general.Others")}( ${obj.total} ${TexTranslateDefault(intl, "general.rest Suppliers")})`;
              }
           
            });
          }
          break;

        case "requisitions":
          if (resultData.header.showTitle === true) {
            
            resultData.header.icon = "bi bi-calendar-event";
            resultData.header.title = "Requisitions";
          }
          if (resultData.dataSummarie && resultData.dataSummarie.length > 0) {
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[0].borderLeftColor = "return";
              resultData.dataSummarie[0].id = "1";
              resultData.dataSummarie[0].state = "Total deserted:";
              resultData.dataSummarie[0].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[1]) {
              resultData.dataSummarie[1].borderLeftColor = "pending";
              resultData.dataSummarie[1].id = "2";
              resultData.dataSummarie[1].state = "Total in process:";
              resultData.dataSummarie[1].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[2].borderLeftColor = "delivered";
              resultData.dataSummarie[2].id = "3";
              resultData.dataSummarie[2].state = "Total processes:";
              resultData.dataSummarie[2].valueFormat = "NUMBER";
            }
          }
          break;
          case "requestsQuotation":
          if (resultData.header.showTitle === true) {
            
            resultData.header.icon = "bi bi-calendar-event";
            resultData.header.title = "Requests for Quotation";
          }
          if (resultData.dataSummarie && resultData.dataSummarie.length > 0) {
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[0].borderLeftColor = "return";
              resultData.dataSummarie[0].id = "1";
              resultData.dataSummarie[0].state = "Total deserted:";
              resultData.dataSummarie[0].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[1]) {
              resultData.dataSummarie[1].borderLeftColor = "pending";
              resultData.dataSummarie[1].id = "2";
              resultData.dataSummarie[1].state = "Total in process:";
              resultData.dataSummarie[1].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[2].borderLeftColor = "delivered";
              resultData.dataSummarie[2].id = "3";
              resultData.dataSummarie[2].state = "Total processes:";
              resultData.dataSummarie[2].valueFormat = "NUMBER";
            }
          }
          break;
          case "registrationsUpdates":
          if (resultData.header.showTitle === true) {
            
            resultData.header.icon = "bi bi-house-door-fill";
            resultData.header.title = "Registrations/Updates";
          }
          if (resultData.dataSummarie && resultData.dataSummarie.length > 0) {
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[0].borderLeftColor = "return";
              resultData.dataSummarie[0].id = "1";
              resultData.dataSummarie[0].state = "Total in invitation:";
              resultData.dataSummarie[0].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[1]) {
              resultData.dataSummarie[1].borderLeftColor = "pending";
              resultData.dataSummarie[1].id = "2";
              resultData.dataSummarie[1].state = "Total pending:";
              resultData.dataSummarie[1].valueFormat = "NUMBER";
            }
            if (resultData.dataSummarie[0]) {
              resultData.dataSummarie[2].borderLeftColor = "delivered";
              resultData.dataSummarie[2].id = "3";
              resultData.dataSummarie[2].state = "Total Registrations:";
              resultData.dataSummarie[2].valueFormat = "NUMBER";
            }
          }
          break;
	      case "contracts":

            if(resultData.header.showTitle === true ){
              resultData.header.icon= "bi bi-patch-check-fill";
              resultData.header.title= "Contracts";
            }
            if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[0].borderLeftColor= "return";
                resultData.dataSummarie[0].id= "1";
                resultData.dataSummarie[0].state= "Total rejected:";
                resultData.dataSummarie[0].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[1]){
                resultData.dataSummarie[1].borderLeftColor= "pending";
                resultData.dataSummarie[1].id= "2";
                resultData.dataSummarie[1].state= "Total pending:";
                resultData.dataSummarie[1].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[2].borderLeftColor= "delivered";
                resultData.dataSummarie[2].id= "3";
                resultData.dataSummarie[2].state= "Total Contracts:";
                resultData.dataSummarie[2].valueFormat = "NUMBER";
              }
            }
            break;

            case "purchaseOrders":

            if(resultData.header.showTitle === true ){
              resultData.header.icon= "bi bi-cart-fill";
              resultData.header.title= "Purchase Orders";
            }
            if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[0].borderLeftColor= "return";
                resultData.dataSummarie[0].id= "1";
                resultData.dataSummarie[0].state= "Total unconfirmed:";
                resultData.dataSummarie[0].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[1]){
                resultData.dataSummarie[1].borderLeftColor= "pending";
                resultData.dataSummarie[1].id= "2";
                resultData.dataSummarie[1].state= "Total Pending:";
                resultData.dataSummarie[1].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[2].borderLeftColor= "delivered";
                resultData.dataSummarie[2].id= "3";
                resultData.dataSummarie[2].state= "Total Purchase Orders:";
                resultData.dataSummarie[2].valueFormat = "NUMBER";
              }
            }
            break;

            case "inputsMaterialsServices":

            if(resultData.header.showTitle === true ){
              resultData.header.icon= "bi bi-truck";
              resultData.header.title= "Inputs Materials/Services";
            }
            if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[0].borderLeftColor= "pending";
                resultData.dataSummarie[0].id= "1";
                resultData.dataSummarie[0].state= "Total Services:";
                resultData.dataSummarie[0].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[1]){
                resultData.dataSummarie[1].borderLeftColor= "pending";
                resultData.dataSummarie[1].id= "2";
                resultData.dataSummarie[1].state= "Total Materials:";
                resultData.dataSummarie[1].valueFormat = "NUMBER";
              }
              if(resultData.dataSummarie[0]){
                resultData.dataSummarie[2].borderLeftColor= "delivered";
                resultData.dataSummarie[2].id= "3";
                resultData.dataSummarie[2].state= "Total Receipts:";
                resultData.dataSummarie[2].valueFormat = "NUMBER";
              }
            }
            break;

            case "concentrationNonconformities":
              if (resultData.header.showTitle === true) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Concentration Nonconformities";
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  if(obj.nombreProveedor === "others" && obj.total){
                    obj.nombreProveedor = `${TexTranslateDefault(intl, "general.Others")}( ${obj.total} ${TexTranslateDefault(intl, "general.rest Suppliers")})`;
                  }
               
                });
              }
              break;
        
              case "evaluations":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-patch-check-fill";
                resultData.header.title= "Evaluations";
              }
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total low rating:";
                  resultData.dataSummarie[0].valueFormat = "NUMBER";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state= "Total pending:";
                  resultData.dataSummarie[1].valueFormat = "NUMBER";
                }
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[2].borderLeftColor= "delivered";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Total satisfactory rating:";
                  resultData.dataSummarie[2].valueFormat = "NUMBER";
                }
              }
              break;

              case "invoicesPayments":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-currency-dollar";
                resultData.header.title= "Invoices and Payments";
              }
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total Pending:";
                  resultData.dataSummarie[0].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state= "Total Overdue:";
                  resultData.dataSummarie[1].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[2].borderLeftColor= "delivered";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Total Paid:";
                  resultData.dataSummarie[2].valueFormat = "MONEY";
                }
              }
              break;

              case "overdues":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-calendar-event";
                resultData.header.title= "Overdues";
              }
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total Overdue:";
                  resultData.dataSummarie[0].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state= "Due date 1-15:";
                  resultData.dataSummarie[1].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[2].borderLeftColor= "pending";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Due date 15-30:";
                  resultData.dataSummarie[2].valueFormat = "MONEY";
                }
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  switch(obj.vencimiento) {
                    case "15D":
                      obj.vencimiento=TexTranslateDefault(intl, "dashboard.Next 15 days")
                    break;
                    case "30D":
                      obj.vencimiento=TexTranslateDefault(intl, "dashboard.Next 30 days")
                    break;
                    case "60D":
                      obj.vencimiento=TexTranslateDefault(intl, "dashboard.Next 60 days")
                    break;
                    
                    default:
                    break;
                }
                });
              }
              break;

              case "concentrationOverdues":
              if (resultData.header.showTitle === true) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Concentration Overdues";
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  if(obj.nombreProveedor === "others" && obj.total){
                    obj.nombreProveedor = `${TexTranslateDefault(intl, "general.Others")}( ${obj.total} ${TexTranslateDefault(intl, "general.rest Suppliers")})`;
                  }
               
                });
              }
              break;

              case "prontoPago":
              
                if(resultData.header.showTitle === true ){
                  resultData.header.icon= "bi bi-currency-exchange";
                  resultData.header.title= "Supplier Financing";
                }
                if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                  if(resultData.dataSummarie[0]){
                    resultData.dataSummarie[0].borderLeftColor= "delivered";
                    resultData.dataSummarie[0].id= "1";
                    resultData.dataSummarie[0].state= "Total financed";
                    resultData.dataSummarie[0].valueFormat = "MONEY";
                  }
                  if(resultData.dataSummarie[1]){
                    resultData.dataSummarie[1].borderLeftColor= "pending";
                    resultData.dataSummarie[1].id= "2";
                    resultData.dataSummarie[1].state= "Total Suppliers:";
                    resultData.dataSummarie[1].valueFormat = "NUMBER";
                  }
                  if(resultData.dataSummarie[2]){
                    resultData.dataSummarie[2].borderLeftColor= "pending";
                    resultData.dataSummarie[2].id= "3";
                    resultData.dataSummarie[2].state= "Average time in days:";
                    resultData.dataSummarie[2].valueFormat = "NUMBER";
                  }
                }
              break;

              case "concentrationFinProveedores":
                if (resultData.header.showTitle === true) {
                  
                  resultData.header.icon = "bi bi-person-fill-up";
                  resultData.header.title = "Concentration of supplier financing";
                }
                if(resultData.dataTable && resultData.dataTable.length > 0){
                  resultData.dataTable.forEach(obj=>{
                    if(obj.nombreProveedor === "others" && obj.total){
                      obj.nombreProveedor = `${TexTranslateDefault(intl, "general.Others")}( ${obj.total} ${TexTranslateDefault(intl, "general.rest Suppliers")})`;
                    }
                 
                  });
                }
                break;

              case "captiva":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-currency-dollar";
                resultData.header.title= "Captiva";
              }
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total Collection:";
                  resultData.dataSummarie[0].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state=  "total negotiated";
                  resultData.dataSummarie[1].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[2].borderLeftColor= "delivered";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Total Disbursed:";
                  resultData.dataSummarie[2].valueFormat = "MONEY";
                }
              }
              break;

              case "delinquentCollection":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-calendar-event";
                resultData.header.title= "Delinquent Collection";
              }
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total delinquency:";
                  resultData.dataSummarie[0].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state= "Next 5 days:";
                  resultData.dataSummarie[1].valueFormat = "MONEY";
                }
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[2].borderLeftColor= "pending";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Next 10 days:";
                  resultData.dataSummarie[2].valueFormat = "MONEY";
                }
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  switch(obj.mora) {
                    case "15D":
                      obj.mora=TexTranslateDefault(intl, "Collection.Next 15 days")
                    break;
                    case "30D":
                      obj.mora=TexTranslateDefault(intl, "Collection.Next 30 days")
                    break;
                    case "45D":
                      obj.mora=TexTranslateDefault(intl, "Collection.Next 45 days")
                    break;
                    case "60D":
                      obj.mora=TexTranslateDefault(intl, "Collection.Next 60 days")
                    break;
                    case "61D":
                      obj.mora=TexTranslateDefault(intl, "Collection.Next 61 days")
                    break;

                    default:
                    break;
                }
                });
              }

              if(resultData.dataTable2 && resultData.dataTable2.length > 0){
                resultData.dataTable2.forEach(obj=>{
                  if(obj.collateralMaturityLabel === "week"){
                    obj.collateralMaturity = `${TexTranslateDefault(intl, "Collection.week")} ${obj.collateralMaturity}`;
                  }
                });
              }
              break;

              case "concentrationCollateral":
              if (resultData.header.showTitle === true) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Concentration Collateral";
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  if(obj.nombreDeudor === "others" && obj.total){
                    obj.nombreDeudor = `${TexTranslateDefault(intl, "general.Others")}( ${obj.total} ${TexTranslateDefault(intl, "general.rest Debtors")})`;
                  }
               
                });
              }
              break;

              case "paymentsPortfolio":
              if (resultData.header.showTitle) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Payments Portfolio";
              }
              if(resultData.dataTable && resultData.dataTable.length > 0){
                resultData.dataTable.forEach(obj=>{
                  if(obj.periodoLabel === "week"){
                    obj.periodo = `${TexTranslateDefault(intl, "Collection.week")} ${obj.periodo}`;
                  }
               
                });
              }
              break;

              case "taxCertificates":

              if(resultData.header.showTitle === true ){
                resultData.header.icon= "bi bi-bank2";
                resultData.header.title= "Tax Certificates";
              }
              
              if(resultData.dataSummarie && resultData.dataSummarie.length > 0){
                if(resultData.dataSummarie[0]){
                  resultData.dataSummarie[0].borderLeftColor= "return";
                  resultData.dataSummarie[0].id= "1";
                  resultData.dataSummarie[0].state= "Total Published";
                  resultData.dataSummarie[0].valueFormat = "NUMBER";
                }
                if(resultData.dataSummarie[1]){
                  resultData.dataSummarie[1].borderLeftColor= "pending";
                  resultData.dataSummarie[1].id= "2";
                  resultData.dataSummarie[1].state=  "Total Suppliers";
                  resultData.dataSummarie[1].valueFormat = "NUMBER";
                }
                if(resultData.dataSummarie[2]){
                  resultData.dataSummarie[2].borderLeftColor= "delivered";
                  resultData.dataSummarie[2].id= "3";
                  resultData.dataSummarie[2].state= "Total Generated";
                  resultData.dataSummarie[2].valueFormat = "NUMBER";
                }
              }
              break;

              case "certificatesCurrent":
              if (resultData.header.showTitle) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Certificates";
                if(resultData.header.period){
                  resultData.header.titleCmp = `${TexTranslateDefault(intl, "Taxes.Certificates")} ${resultData.header.period}`
                }
              }
              break;

              case "certificatesPast":
              if (resultData.header.showTitle) {
                
                resultData.header.icon = "bi bi-reception-3";
                resultData.header.title = "Certificates";
                if(resultData.header.period){
                  resultData.header.titleCmp = `${TexTranslateDefault(intl, "Taxes.Certificates")} ${resultData.header.period}`
                }
              }
              break;
        
        default:
          break;
      }

    }
    return resultData;

  };

  const rnValor = (val) => {
    if (val !== undefined && val !== null && val !== "") {
        return (parseFloat(val).toLocaleString('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits : 0,
            maximumFractionDigits : 0
        }));
    } else {
        return (`COP$ ${0}`);
    }
  }

  const rnMoney = (val) => {
    if (val !== undefined && val !== null && val !== "") {
        return (parseFloat(val).toLocaleString('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits : 0,
            maximumFractionDigits : 0
        }));
    } else {
        return (`$ ${0}`);
    }
  }
  
  const rnInteger = (val) => {
    if (val !== undefined && val !== null && val !== "") {
        return (parseFloat(val).toLocaleString('es-CO', {
            minimumFractionDigits : 0,
            maximumFractionDigits : 0,
            useGrouping: true,
            groupingSeparator: '.',
            decimalSeparator: ','
        }));
    } else {
        return (`${0}`);
    }
  }

  const rnPercentageNoDecimal = (val) => {
    if (val !== undefined && val !== null && val !== "") {
        return (parseFloat(val).toLocaleString('es-CO', {
            minimumFractionDigits : 0,
            maximumFractionDigits : 0,
            style: 'percent',
            useGrouping: true,
            groupingSeparator: '.',
            decimalSeparator: ','
        }));
    } else {
        return (`${0}`);
    }
  }

  const rnProgressBar = (val) => {
    const percentage = val * 100;
    const valuePorcentaje = rnPercentageNoDecimal(val);
    const progressBarValue = (
      <ProgressBarValue 
        porcentaje={percentage} 
        componentValue={valuePorcentaje} 
        side={"right"}
      />
    );
    return progressBarValue;
  }
  
  const columnasRenderCOpportunities = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "nombreProveedor", "label": "Supplier", "className": "table-text-center",},
    {"name": "cantOfert", "label": "No. Bids", "className": "table-text-center",},
    {"name": "cantOtorgada", "label": "No. Awarded", "className": "table-text-center",},
    {"name": "porcentaje", "label": "%", "className": "table-text-center",}
    
  ];

  const columnasRenderCNonconformities = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "nombreProveedor", "label": "Supplier", "className": "table-text-center",},
    {"name": "cantNC", "label": "No. NC", "className": "table-text-center",},
    {"name": "cantResueltas", "label": "No. Solved", "className": "table-text-center",},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderOverdues = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "vencimiento", "label": "Due date", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderCOverdues = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "nombreProveedor", "label": "Supplier", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end",},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderCFinProveedores = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "nombreProveedor", "label": "Supplier", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderDelinquentCollection = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "mora", "label": "Delinquent", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderCollateralMaturity = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "collateralMaturity", "label": "collateralMaturity", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderPaymentsPortfolio = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "periodo", "label": "Period", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor}
    
  ];


  const columnasRenderCCollateral = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "nombreDeudor", "label": "Debtor", "className": "table-text-center",},
    {"name": "cantFacturas", "label": "No. Invoices", "className": "table-text-center",},
    {"name": "monto", "label": "Amount", "className": "table-text-end","render": rnValor},
    {"name": "porcentaje", "label": "%", "className": "table-text-end",}
    
  ];

  const columnasRenderCertCurrent = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "tipoCerti", "label": "Type of Certificate", "className": "table-text-center minW-300",},
    {"name": "cantRetenidos", "label": "Number of Retained", "className": "table-text-center","render": rnInteger},
    {"name": "cantCerti", "label": "Number of Certificates", "className": "table-text-center","render": rnInteger},
    {"name": "penetracion", "label": "Penetration", "className": "table-text-end","render": rnProgressBar},
    {"name": "totalBaseRet", "label": "Total Withholding Base", "className": "table-text-end","render": rnMoney},
    {"name": "totalRet", "label": "Total Withholding", "className": "table-text-end","render": rnMoney}
  ];

  const columnasRenderCertPast = [
    // Row
    {
      "key": "key", "classRow": ""
    },
    // Col
    {"name": "tipoCerti", "label": "Type of Certificate", "className": "table-text-center minW-300",},
    {"name": "cantRetenidos", "label": "Number of Retained", "className": "table-text-center","render": rnInteger},
    {"name": "cantCerti", "label": "Number of Certificates", "className": "table-text-center","render": rnInteger},
    {"name": "penetracion", "label": "Penetration", "className": "table-text-end","render": rnProgressBar},
    {"name": "totalBaseRet", "label": "Total Withholding Base", "className": "table-text-end","render": rnMoney},
    {"name": "totalRet", "label": "Total Withholding", "className": "table-text-end","render": rnMoney}
  ];

  const dataProcess = processResumeType(data);
  
  return (
    <React.Fragment>

      <SummariesHeader headerData={dataProcess.header} dictionary={dictionary} />
      {
        dataProcess.header.showSummarie &&
          <SummariesItems itemsData={dataProcess.dataSummarie} dictionary={dictionary} />
      }

      {dataProcess.header.showTable && dataProcess.header.module === "concentrationOpportunities" &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCOpportunities}
              classNameRow={"row-dashboard"}
              keyTranslate="sourcing"
              tipoTable="general"
              countRows={4}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "concentrationNonconformities"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCNonconformities}
              classNameRow={"row-dashboard"}
              keyTranslate="Procurement"
              tipoTable="general"
              countRows={4}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "overdues"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderOverdues}
              classNameRow={"row-dashboard"}
              keyTranslate="Financing"
              tipoTable="general"
              countRows={3}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "concentrationOverdues"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCOverdues}
              classNameRow={"row-dashboard"}
              keyTranslate="Financing"
              tipoTable="general"
              countRows={4}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "concentrationFinProveedores"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCFinProveedores}
              classNameRow={"row-dashboard"}
              keyTranslate="Financing"
              tipoTable="general"
              countRows={6}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "delinquentCollection"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderDelinquentCollection}
              classNameRow={"row-dashboard"}
              keyTranslate="Collection"
              tipoTable="general"
              countRows={3}
            />}
          </div>

          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable2 && dataProcess.dataTable2}
              columnasRender={columnasRenderCollateralMaturity}
              classNameRow={"row-dashboard"}
              keyTranslate="Collection"
              tipoTable="general"
              countRows={3}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "concentrationCollateral"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCCollateral}
              classNameRow={"row-dashboard"}
              keyTranslate="Collection"
              tipoTable="general"
              countRows={3}
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "certificatesCurrent"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCertCurrent}
              classNameRow={"row-dashboard"}
              keyTranslate="Taxes"
              tipoTable="general"
              countRows={3}
              emptyMsg="msg_empty_grid"
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "certificatesPast"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderCertPast}
              classNameRow={"row-dashboard"}
              keyTranslate="Taxes"
              tipoTable="general"
              countRows={3}
              emptyMsg="msg_empty_grid"
            />}
          </div>
         
        </div>
      }

      {dataProcess.header.showTable && dataProcess.header.module === "paymentsPortfolio"  &&
        // Tabla resumen
        <div className="details">
         
          <div className="content_module grid_rfp mt-3">
            {<Grid 
              datas={dataProcess.dataTable && dataProcess.dataTable}
              columnasRender={columnasRenderPaymentsPortfolio}
              classNameRow={"row-dashboard"}
              keyTranslate="Collection"
              tipoTable="general"
              countRows={3}
            />}
          </div>
         
        </div>
      }

    </React.Fragment>
  )
}
